import axiosClient from "../../../../axiosClient"

export default async (id) => {
    const result = await axiosClient.get(`/interim-report/${id}`)

    return result.data
}
